import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Checkbox,
	Grid,
	Paper,
	Alert,
	TextField,
	FormControlLabel,
	Box
} from "@mui/material";
import { pink } from "@mui/material/colors";
import {
	firstFieldFilterAppealsList_v2,
	secondFieldFilterAppealsList_v2
} from "../../../../constants/fieldsList/FieldsList";
import { handleChangeHeader } from "../../../../utils/commonFunctions/fieldCapitalize";
import AppealCustomFilter from "./appealsCustomFilter/AppealCustomFilter";
import PaidClaimsCustomFilter from "./paidClaimsCustomFilter/PaidClaimsCustomFilter";
import IDRTrackersCustomFilter from "./idrTrackersCustomFilter/IDRTrackersCustomFilter";
import { DynamicFiltersModalProps, FilterState } from "../../../../@types/appealReportAllprops.types";
import { DateFilter } from "../../../../@types/dateFilter.types";

// Interface for filter type

const DynamicFiltersModal: React.FC<DynamicFiltersModalProps> = ({
	open,
	onClose,
	filteredColumns,
	handleUpdateFiltersSelection,
	handleFilterChange,
	ensureDateFilter,
	appealsIDRTrackersCommonUnion,
	filters
}) => {
	// Determine the appropriate input type for the filter
	const getInputType = (field: string) => {
		const dateFields = [
			"closure_ltr_date",
			"date_of_service",
			"cheque_mailed",
			"cheque_cleared",
			"cheque_received",
			"reissued",
			"open_negotiation_notice_end_of_right_to_initiate_on",
			"open_negotiation_notice_received_date",
			"open_negotiation_period_ending",
			"notice_of_idr_initiation_end_of_right_to_initiate",
			"notice_of_idr_initiation_received_date",
			"selection_of_certified_idr_entity",
			"final_selection_of_idr_entity",
			"submission_of_offer",
			"selection_of_offer_and_decision",
			"payment_of_oon_rate",
			"cooling_off_period",
			"updated_date",
			"first_appeal_received",
			"date_to_send_first_appeal_response",
			"first_appeal_response_date",
			"submission_of_offer",
			"idr_decision_date",
			"open_negotiation_response_date",
			"updatedAt",
			"createdAt",
			"admin_fee_date"
		];

		const numberFields = [
			"total_charge",
			"allowable",
			"paid",
			"discount",
			"savings",
			"TPA_fee",
			"other_fee",
			"net_savings",
			"percentage_savings",
			"cheque_number",
			"agreement_sent"
		];

		const booleanFields = [
			"is_void",
			"is_all_claims",
			"is_check_status_requested",
			"is_closure_letter_required",
			"is_closure_letter_completed",
			"fees_paid"
		];

		// console.log("inputtype", field, dateFields.includes(field));

		if (dateFields.includes(field)) return "date";
		if (numberFields.includes(field)) return "number";
		if (booleanFields.includes(field)) return "boolean";
		return "text";
	};

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
			<DialogTitle>
				<h4 style={{ color: "#ab455c", textAlign: "center", marginBottom: "0.2rem" }}>
					Select Column Headers for filtering Claim Report
				</h4>
			</DialogTitle>
			<DialogContent>
				<Alert
					severity="warning"
					sx={{
						fontSize: "1rem",
						margin: "auto",
						marginTop: "10px",
						marginBottom: "10px",
						textAlign: "center",
						width: "fit-content"
					}}
					className="disclaimer-container"
				>
					<strong className="disclaimer">Disclaimer:</strong> Checking the field will allow to filter the
					claims Report by that field
				</Alert>
				<Paper elevation={3} style={{ borderRadius: "15px", padding: "2rem" }}>
					{/* <div
						style={{
							width: "100%",
							margin: "auto",
							textAlign: "center",
							fontWeight: "bolder",
							color: "#ab455c",
							fontSize: "20px",
							marginBottom: "20px"
						}}
					>
						Paid Claims
					</div>
					<div className="fieldContainer">
						<Grid container spacing={4}>
							{[firstFieldFilterAppealsList_v2, secondFieldFilterAppealsList_v2].map(
								(fieldList, columnIndex) => (
									<Grid item xs={12} sm={12} md={6} key={columnIndex}>
										<Grid
											container
											style={{ marginBottom: "1rem", color: "#ab455c", fontWeight: "bold" }}
										>
											<Grid item xs={6}>
												FIELD NAME
											</Grid>
											<Grid item xs={6} style={{ textAlign: "center" }}>
												VIEW
											</Grid>
										</Grid>
										{fieldList.map((field, index) => (
											<Grid
												container
												key={index}
												style={{ marginBottom: "1rem" }}
												alignItems="center"
											>
												<Grid item xs={6}>
													{handleChangeHeader(field).replace("CHEQUE", "CHECK")}
												</Grid>
												<Grid item xs={6} style={{ textAlign: "center" }}>
													<Checkbox
														checked={filteredColumns[field]}
														sx={{
															color: pink[800],
															"&.Mui-checked": { color: pink[600] }
														}}
														onChange={(event: any) =>
															handleUpdateFiltersSelection(field, event.target.checked, "paid_claims")
														}
													/>
												</Grid>
												{filteredColumns[field] && (
													<Grid container spacing={2}>
														{getInputType(field) === "date" && (
															<>
																<Grid item xs={6}>
																	<TextField
																		fullWidth
																		label="Start Date"
																		type="date"
																		value={ensureDateFilter(field).startDate}
																		onChange={(e: any) =>
																			handleFilterChange(field, {
																				...ensureDateFilter(field),
																				startDate: e.target.value
																			})
																		}
																		InputLabelProps={{
																			shrink: true // Keep label visible
																		}}
																	/>
																</Grid>
																<Grid item xs={6}>
																	<TextField
																		fullWidth
																		label="End Date"
																		type="date"
																		value={ensureDateFilter(field).endDate}
																		onChange={(e: any) =>
																			handleFilterChange(field, {
																				...ensureDateFilter(field),
																				endDate: e.target.value
																			})
																		}
																		InputLabelProps={{
																			shrink: true // Keep label visible
																		}}
																	/>
																</Grid>
															</>
														)}
														{getInputType(field) === "number" && (
															<Grid item xs={12}>
																<TextField
																	fullWidth
																	label="Enter Value"
																	type="number"
																	value={filters[field] || ""}
																	onChange={(e: any) =>
																		handleFilterChange(field, e.target.value)
																	}
																	InputLabelProps={{
																		shrink: true
																	}}
																/>
															</Grid>
														)}
														{getInputType(field) === "text" && (
															<Grid item xs={12}>
																<TextField
																	fullWidth
																	label="Enter Value"
																	type="text"
																	value={filters[field] || ""}
																	onChange={(e: any) =>
																		handleFilterChange(field, e.target.value)
																	}
																	InputLabelProps={{
																		shrink: true
																	}}
																/>
															</Grid>
														)}
														{getInputType(field) === "boolean" && (
															<Grid item xs={12}>
																<FormControlLabel
																	control={
																		<Checkbox
																			checked={filters[field] === true}
																			onChange={(e: any) =>
																				handleFilterChange(
																					field,
																					e.target.checked
																				)
																			}
																			color="primary"
																		/>
																	}
																	label="True"
																/>
																<FormControlLabel
																	control={
																		<Checkbox
																			checked={filters[field] === false}
																			onChange={(e: any) =>
																				handleFilterChange(
																					field,
																					!e.target.checked
																				)
																			}
																			color="secondary"
																		/>
																	}
																	label="False"
																/>
															</Grid>
														)}
													</Grid>
												)}
											</Grid>
										))}
									</Grid>
								)
							)}
						</Grid>
					</div> */}
					<PaidClaimsCustomFilter
						filteredColumns={filteredColumns}
						handleUpdateFiltersSelection={handleUpdateFiltersSelection}
						handleFilterChange={handleFilterChange}
						ensureDateFilter={ensureDateFilter}
						getInputType={getInputType}
						filters={filters}
					/>
					{appealsIDRTrackersCommonUnion.appeals && (
						<AppealCustomFilter
							filteredColumns={filteredColumns}
							handleUpdateFiltersSelection={handleUpdateFiltersSelection}
							handleFilterChange={handleFilterChange}
							ensureDateFilter={ensureDateFilter}
							getInputType={getInputType}
							filters={filters}
						/>
					)}

					{appealsIDRTrackersCommonUnion.idrtrackers && (
						<IDRTrackersCustomFilter
							filteredColumns={filteredColumns}
							handleUpdateFiltersSelection={handleUpdateFiltersSelection}
							handleFilterChange={handleFilterChange}
							ensureDateFilter={ensureDateFilter}
							getInputType={getInputType}
							filters={filters}
						/>
					)}
				</Paper>
			</DialogContent>
			<DialogActions>
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						width: "100%"
					}}
				>
					<Button variant="contained" style={{ backgroundColor: "#ab455c" }} onClick={onClose}>
						OK
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
};

export default DynamicFiltersModal;
